import { render } from "./GiftLinks.vue?vue&type=template&id=2a3d92a4&ts=true"
import script from "./GiftLinks.vue?vue&type=script&lang=ts"
export * from "./GiftLinks.vue?vue&type=script&lang=ts"

import "./GiftLinks.vue?vue&type=style&index=0&id=2a3d92a4&lang=css"

import exportComponent from "/builds/clickfun/frontend/clickfun_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__